/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { MyLibraryTeacherCandidatesFilterViewModel } from "../types/MyLibraryTeacherCandidatesFilterViewModel.ts";

export const myLibraryTeacherCandidatesFilterViewModelSchema = z.object({
  filter: z
    .string()
    .describe(
      "Texto de busca aplicado ao nome ou ao e-mail do professor. A comparação ignora maiúsculas e minúsculas. Opcional.",
    )
    .nullish(),
}) as unknown as ToZod<MyLibraryTeacherCandidatesFilterViewModel>;
